import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, ButtonsWrapper, Form } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';

import { PersonalInfo } from '../personal-info';
import { EmergencyContact } from '../emergency-contact';
import { PaymentAndInsurance } from '../payment-and-insurance';
import { EducationsAndSkills } from '../educations-and-skills';

import { IAcceptEmployeeFormProps } from '../../accept-questionnaire.interfaces';

const QuestionnaireForm = ({
  initialValues,
  onFinish,
  loading,
}: IAcceptEmployeeFormProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('employee');
  const [form] = Form.useForm();

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      scrollToFirstError
      initialValues={initialValues}
    >
      <PersonalInfo parentField={'employeePersonalInfo'} />

      <PaymentAndInsurance form={form} />

      <EducationsAndSkills />

      <EmergencyContact />

      <ButtonsWrapper marginTop={16}>
        <Button type="primary" loading={loading} htmlType="submit">
          {t('common:buttons.accept')}
        </Button>
        <Button onClick={() => navigate(ROUTES.employee)}>{t('common:buttons.cancel')}</Button>
      </ButtonsWrapper>
    </Form>
  );
};

export default QuestionnaireForm;
